function customAddToCart() {
  var qtyInputs = $('.nm-easywholesale-qty')
  var minQty = true
  var isCatering = false;
  var cateringMinQty = false;

  if (window.location.href.indexOf("/products/individual-christmas-cookies") > -1
      || window.location.href.indexOf("/products/wrapped-christmas-puddings") > -1
      || window.location.href.indexOf("/products/traditional-yule-log") > -1
      || window.location.href.indexOf("/products/fruit-mince-tarts") > -1
      || window.location.href.indexOf("/products/decorated-christmas-fruit-cake") > -1
      || window.location.href.indexOf("/products/christmas-cupcakes-6-pack") > -1
      || window.location.href.indexOf("/products/christmas-fondant-cookies") > -1
      || window.location.href.indexOf("/products/white-christmas-slice") > -1
      || window.location.href.indexOf("/products/wrapped-christmas-fruit-cake") > -1
      || window.location.href.indexOf("/products/christmas-dinner-lunch-deluxe-bundle") > -1) { 
    $('.nm-wholesale-btn-add-to-cart').click()
    return;
  } 
  
  if (window.location.href.indexOf("/products/sweet-catering") > -1
    || window.location.href.indexOf("/products/savoury-catering") > -1) {
    isCatering = true;
  }  

  $('.cooked-frozen-error').remove()
  $('.qty-error').remove()
  
  $(qtyInputs).each(function(index) {
    var inputValue = parseInt(qtyInputs[index].value)

    if (inputValue > 0 && isCatering) { 
      cateringMinQty = true
    } 
    
    if (inputValue > 0 && inputValue < 6) {
      minQty = false
    }
  })
  
  if ((minQty && !isCatering) || (isCatering && cateringMinQty)) { 
  	$('.nm-wholesale-btn-add-to-cart').click()
  } else if (isCatering && !cateringMinQty) {
    $('.nm-easywholesale-footer').after('<p class="qty-error">Please add at least one item.</p>')
  } else {
  	$('.nm-wholesale-btn-add-to-cart').click()
    // $('.nm-easywholesale-footer').after('<p class="qty-error">Please add the minimum quantity (6) of each selected items.</p>')
  } 
}
$('.ot-delivery-date-input').show();

$(document).ready(function(){
  //Custom cake carousel
  $('#cc').owlCarousel({
    loop: true,
    center:true,
    margin: 20,
    autoplay:true,
    autoplayTimeout:2000,
    nav: false,
    dots: false,
    responsive:{
      0:{
        items: 1
      },
      600:{
        items: 3
      },
      1000:{
        items: 3,
      }
    }
  });
  
  //Post code accordeon
  $(".rd").on("click", function () {
    $(this).hide();
    $(".surb2").show();
  });

  if (window.location.href.indexOf("/collections/wedding-engagement") > -1
      || window.location.href.indexOf("/collections/him") > -1
      || window.location.href.indexOf("/collections/her") > -1
      || window.location.href.indexOf("/collections/christening-baptism") > -1
      || window.location.href.indexOf("/collections/baby-shower") > -1
      || window.location.href.indexOf("/collections/smash-cakes") > -1
      || window.location.href.indexOf("/collections/build-your-own-naked-cake") > -1
      || window.location.href.indexOf("/collections/all") > -1) {   
    $('.filters-toolbar-wrapper').before(`
      <div class="rte collection-description page-width">
        <center>
          <p style="max-width: 800px;">  
            <strong>
              <span style="color:red;">TIP</span>
              <br><br>
              You will have an option to change colours on most cakes if desired. (E.g. if you see a cake that is is purple or purple themed you can have the same cake style but in a different colour or colour theme)
            </strong>
          </p>
        </center>
      </div>                                     
    `) 
  }      
   
  if (window.location.href.indexOf("/collections") > -1 && window.location.href.indexOf("/collections/") == -1) {
    var specialityCakesLink = $('div.h3:contains(Speciality Cakes)')[0].parentElement.parentElement
    $(specialityCakesLink).click(function(e) {
      e.preventDefault() 
      window.location.href = '/pages/speciality-cakes' 
    })
  }
  
  var postcodesUrl = $('#postcodes_url').val()
 
  //get a list of available postcodes
  function getPostcodes(postcodesUrl) {
  var response = false;
  $.ajax({
    type: 'GET', 
    url: postcodesUrl, 
    dataType: 'JSON',
    async: false,
    success: function (data) {
      response = data;
    }
  });
  return response;
}

  $(document).on("keyup","#shipping-zipcode",function() {
      var input = $(this);
      var value = $(this).val();
      $(".post-code-label").hide(); 
      input.parent().removeClass("has-error has-success");
    
      if (document.location.href.match(/\/products\//ig)) {
        // $('#custom-add-to-cart').attr('disabled', true) 
      }
    
      if(value.length == 4){
          input.parent().addClass("has-error");
          //$(".post-code-label").text("Sorry! :( We are not delivering that far just yet, subscribe to our newsletter and we will let you know when we reach that suburb")
          $(".post-code-label").html("Sorry! :( We are not delivering that far just yet, but you can select Pick Up at checkout. <br><br> If we cant deliver to your suburb and you are ordering an Speciality Cake, please contact <a style='color: #a94442; text-decoration:underline;' href='mailto:ricky@polespatisserie.com.au'>ricky@polespatisserie.com.au</a> and he might be able to help you organise delivery")
          $.each(getPostcodes(postcodesUrl), function(index, element) {
              if (value == element.post_code) {
                  input.parent().removeClass("has-error").addClass("has-success");
                  $(".post-code-label").text("Whoop whoop! We can reach you!");
                  
                  if (document.location.href.match(/\/products\//ig)) {
                    $('#custom-add-to-cart').removeAttr('disabled')
                  }
                
                  return false;
              }
          });
          $(".post-code-label").show();          
      }
  });

  $(".site-nav--has-dropdown").removeClass("site-nav--has-centered-dropdown");

  var detectCakeFields = setInterval(function() {
    if ($('.cake-age-opt').length > 0) {
      $('.cake-age-opt').find('input[type=number]').attr('max', '99')    
      $('.cake-age-opt').find('input[type=number]').keyup(validateMaxLength)
      $('.cake-name-opt').find('input[type=text]').attr('maxlength', '10') 
      $('.cake-name-opt').find('input[type=text]').attr('onkeydown', 'return /[a-z ]/i.test(event.key)')
      
      function validateMaxLength() {
        var text = $(this).val()
        var maxlength = 2

        if(maxlength > 0) {
          $(this).val(text.substr(0, maxlength)) 
        }
      }   
      clearInterval(detectCakeFields)    
    } 
  })

  var detectCakeTopper = setInterval(function() {
    if ($('.cake-topper-opt').length > 0) {
      // $('.cake-age-opt').find('input[type=number]').attr('max', '99')    

      $('input[name="properties[PLEASE SELECT YOUR TOPPER OPTION]"]').change(function() {
        if (this.value == 'Number Topper [ $20.00 ]') {
          $('.cake-number-opt').find('input[type=text]').attr('maxlength', '2')
          $('.cake-number-opt').find('input[type=text]').attr('oninput', "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*?)\\..*/g, '$1')")
          $('.cake-number-opt').find('input[type=text]').removeAttr('onkeydown')
        } else if (this.value == 'Number Font Topper [ $20.00 ]') {
          $('.cake-number-opt').find('input[type=text]').attr('maxlength', '20')
          $('.cake-number-opt').find('input[type=text]').attr('onkeydown', 'return /[a-z ]/i.test(event.key)')
          $('.cake-number-opt').find('input[type=text]').removeAttr('oninput')
        }
      })
      
      clearInterval(detectCakeTopper)    
    } 
  })

  var detectBoardText = setInterval(function() {
    if ($('.board-text-opt').length > 0) {
      $('.board-text-opt').find('input[type=text]').attr('maxlength', '30')
      clearInterval(detectBoardText)    
    } 
  })

  if  (window.location.href.indexOf("/products/wrapped-christmas-fruit-cake") > -1) {
    $('.product-form-product-template').hide() 
  }
  
  if (window.location.href.indexOf("/products/cannoli") > -1
      || window.location.href.indexOf("/products/fun-kids-cupcakes") > -1
      || window.location.href.indexOf("/products/muffins") > -1
      || window.location.href.indexOf("/products/sweet-catering") > -1
      || window.location.href.indexOf("/products/savoury-catering") > -1
      || window.location.href.indexOf("/products/individual-christmas-cookies") > -1
      || window.location.href.indexOf("/products/wrapped-christmas-puddings") > -1
      || window.location.href.indexOf("/products/traditional-yule-log") > -1
      || window.location.href.indexOf("/products/fruit-mince-tarts") > -1
      || window.location.href.indexOf("/products/decorated-christmas-fruit-cake") > -1
      || window.location.href.indexOf("/products/key-lime-tart-7") > -1
      || window.location.href.indexOf("products/lemon-meringue-7") > -1
      || window.location.href.indexOf("/products/almond-tart-7") > -1
      || window.location.href.indexOf("/products/salted-caramel-tart-7") > -1
      || window.location.href.indexOf("/products/fruit-flan-tart-7") > -1
      || window.location.href.indexOf("/products/almond-tart-7") > -1
      || window.location.href.indexOf("/products/custard-tart-7") > -1
      || window.location.href.indexOf("/products/4-frozen-pies") > -1
      || window.location.href.indexOf("/products/apple-charlotte-pie-7") > -1
      || window.location.href.indexOf("/products/pavlova-7") > -1
      || window.location.href.indexOf("/products/apple-pie-7") > -1
      || window.location.href.indexOf("/products/diplomat-pudding-7") > -1
      || window.location.href.indexOf("/products/christmas-cupcakes-6-pack") > -1
      || window.location.href.indexOf("/products/christmas-fondant-cookies") > -1
      || window.location.href.indexOf("/products/white-christmas-slice") > -1
      || window.location.href.indexOf("/products/wrapped-christmas-fruit-cake") > -1
      || window.location.href.indexOf("/products/christmas-dinner-lunch-deluxe-bundle") > -1
      || window.location.href.indexOf("/products/apple-teacake") > -1
      || window.location.href.indexOf("/products/banoffee-tart") > -1
      || window.location.href.indexOf("/products/filled-hot-cross-buns-4pack") > -1
      || window.location.href.indexOf("/products/donations-support-the-mcgrath-foundation") > -1) {    
    $('.nm-easywholesale-add-to-cart-container').before('<button type="button" class="custom-product-add-to-cart" onclick="customAddToCart()">ADD TO CART</button>')
  }  

  if (window.location.href.indexOf("/products/sweet-catering") > -1
    || window.location.href.indexOf("/products/savoury-catering") > -1
    || window.location.href.indexOf("/products/key-lime-tart-7") > -1
    || window.location.href.indexOf("products/lemon-meringue-7") > -1
    || window.location.href.indexOf("/products/almond-tart-7") > -1
    || window.location.href.indexOf("/products/salted-caramel-tart-7") > -1
    || window.location.href.indexOf("/products/fruit-flan-tart-7") > -1
    || window.location.href.indexOf("/products/custard-tart-7") > -1
    || window.location.href.indexOf("/products/4-frozen-pies") > -1
    || window.location.href.indexOf("/products/apple-charlotte-pie-7") > -1
    || window.location.href.indexOf("/products/pavlova-7") > -1
    || window.location.href.indexOf("/products/apple-pie-7") > -1
    || window.location.href.indexOf("/products/diplomat-pudding-7") > -1) {
    $('.product__price dl').remove() 
    $('.product__policies').remove()
  }      

  if (window.location.href.indexOf("/products/cannoli") > -1) {
    
  }

  if ($("label:contains(Size)").length > 0) { 
    $($("label:contains(Size)")[0].control).after('<p class="size-chart" style="margin-top:10px;margin-bottom:-20px;"><a href="#" id="cake-size" style="display:inline-flex;align-items:center;gap:0.35rem;padding:0.5rem 0.85rem;background:#f8a48d;color:#fff !important;font-size:0.8rem;font-weight:600;letter-spacing:0.02em;text-transform:uppercase;text-decoration:none;border-radius:6px;border:none;cursor:pointer;transition:opacity 0.2s;"><svg style="width:1.1em;height:1.1em;flex-shrink:0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 21h12M9 21V12m6 9V12M3 12h18v9H3V12zM3 9l2-4h14l2 4H3z"/></svg>Check the size serving suggestion</a></p>')     
    
    $($("label:contains(Size)")[0].control).on('change', function() { 
      $('.gf-decorations-warning').remove() 
      var size = $(this)[0].value
      if (size.includes('Gluten Free')) { 
        $($("label:contains(Size)")[0].control).after('<p class="gf-decorations-warning">PLEASE BE AWARE THAT THE DECORATIONS ON THE TOP WILL VARY AS TO BE ABLE TO MAKE THIS CAKE GLUTEN FREE</p>'); 
      }  
    })
  }   

  if ($("label:contains(SIZE)").length > 0) { 
    $($("label:contains(SIZE)")[0].control).on('change', function() {
      $('.gf-decorations-warning').remove() 
      var size = $(this)[0].value
      if (size.includes('Gluten Free')) {
        $($("label:contains(SIZE)")[0].control).after('<p class="gf-decorations-warning">PLEASE BE AWARE THAT THE DECORATIONS ON THE TOP WILL VARY AS TO BE ABLE TO MAKE THIS CAKE GLUTEN FREE</p>'); 
      }  
    })
  }

  $('.search-bar__close').click(function() {
    $('#shopify-section-0c2b97c3-d073-4f84-95db-5051acabfca6').css('margin-top', '0px') 
  })

  
  $(".filters-toolbar__input option[value='/collections/all/bulk']").remove();

  // $.getScript("https://api.tybo.agency/tybo/banner/banner.js", function() { 
  //   initBanner()
  // }); 
  
  /*if ($('p:contains(20-25)').length > 0) {
     var sizeOneCake = $('p:contains(20-25)')[0].textContent
     sizeOneCake = sizeOneCake.replace('20-25', '12-14')
     sizeOneCake = sizeOneCake.replace('35-40', '20-25')
     sizeOneCake = sizeOneCake.replace('Dessert Slice', 'Dessert Slices')
     sizeOneCake = sizeOneCake.replace('Coffee Slice', 'Coffee Slices')
     $('p:contains(20-25)').text(sizeOneCake) 
  }   

  if ($('p:contains(40-45)').length > 0) { 
    var sizeTwoCake = $('p:contains(40-45)')[0].textContent
  	sizeTwoCake = sizeTwoCake.replace('40-45', '30-35')
  	sizeTwoCake = sizeTwoCake.replace('60-65', '40-45')
  	$('p:contains(40-45)').text(sizeTwoCake)
  }*/ 

  if ($('p:contains(nice and soft and ideal for smashing!)').length > 0) {
    var smashCakeDescription = $('p:contains(nice and soft and ideal for smashing!)')[0].textContent
    smashCakeDescription = smashCakeDescription.replace('smashing!', 'smashing, <span style="color:red;"><strong>and not suitable for a birthday celebration cake</strong></span>')
    $('p:contains(nice and soft and ideal for smashing!)').html(smashCakeDescription) 
  }   

  if (window.location.href.indexOf("/products/complex-finish-fondant-cupcake") > -1
      || window.location.href.indexOf("/products/mini-figurine-cupcake") > -1
      || window.location.href.indexOf("/products/simple-finish-fondant-cupcakes") > -1
      || window.location.href.indexOf("/products/fun-kids-cupcakes") > -1 
      || window.location.href.indexOf("/products/2-colours-swirl-cupcake") > -1) {
    $('.product-form__cart-submit').hide() 
    
    $(".product-form__input--quantity").bind('keyup mouseup', function () { 
      if ($('.product-form__input--quantity').val() >= 6) {
        $('.product-form__cart-submit').show()
      } else {
        $('.product-form__cart-submit').hide()
      }         
    })
  }

  $($('.site-footer__linklist-item:contains(Custom Cakes)')[0].children[0]).attr('style', 'color: #fee9e1 !important') 
  
});

function customAddToCartNakedCakes() {
  var selectedOptions = 0
  $('select').each(function(index) {
    if ($('select')[index].value == 'Yes Please') {
      selectedOptions += 1
    } 
  })

  if (selectedOptions >= 2) {
    $('.product-form__cart-submit').click()
  } else {
    $('.naked-cake-options').show()
  }
}

jQuery(document).ready(function ($) {
   $('.gc-show-more-toggle').click(function (e) {
       e.preventDefault();
       $('.gc-show-more-container').children('.gc-show-more-content').slideToggle("300");
       $(this).toggleClass('gc-show-more-toggle_active');
       if ($(this).hasClass('gc-show-more-toggle_active')) {
        $(this).html('Read less...');
       }else {
        $(this).html('Read more...');
    }
   });
  
});

jQuery(document).ready(function($) {
    $('.btn--link.site-header__icon').click(function() {
        var section = $('#shopify-section-0c2b97c3-d073-4f84-95db-5051acabfca6');
        if ($(this).hasClass('mobile-nav--open')) {
            // If the button is in the "open" state, add margin
            section.css('margin-top', '0px');
        } else {
            // If the button is in the "close" state, remove margin
            section.css('margin-top', '145px');
        }
    });
});